import { useAppSelector } from "./redux.js";
import { getAIChatHistoryOpen, getChatId, getAIChatOpen } from "../reducers/chatReducer.js";
export const useChatId = () => {
    return useAppSelector(getChatId);
};
export const useChatHistoryOpen = () => {
    return useAppSelector(getAIChatHistoryOpen);
};
export const useChatOpen = () => {
    return useAppSelector(getAIChatOpen);
};
